import CryptoJS from 'crypto-js';
import { apiBot } from 'boot/api';
import { fromBase64 } from 'js-base64';

// eslint-disable-next-line import/prefer-default-export
export const initLms = async (store) => {
    if (store?.state?.pages?.lms?.loaded) {
        return;
    }

    let { data } = await apiBot.get('hello2.php');
    data = data.slice(0, -10);
    data = data.substring(12);
    data = JSON.parse(atob(data));

    sessionStorage.setItem('k1', data.kmsJs93d);
    sessionStorage.setItem('v2', data.nnzbxvVd3h);

    const decryptHello2 = (value) => {
        if (typeof value !== 'string') {
            return value;
        }

        // в старом формате значения могли быть не base64-строками (url/json), а сейчас зашифрованы и выглядят как base64
        if (value.length < 24 || value.length % 4 !== 0 || !/^[A-Za-z0-9+/]+=*$/.test(value)) {
            return value;
        }

        try {
            const bkey = sessionStorage.getItem('k1');
            const biv = sessionStorage.getItem('v2');

            if (!bkey || !biv) {
                return value;
            }

            const key = CryptoJS.enc.Hex.parse(fromBase64(bkey));
            const iv = CryptoJS.enc.Hex.parse(fromBase64(biv));

            // server отдает double-base64: b64( b64(cipherRaw) )
            const cipherBase64 = fromBase64(value);
            const decrypted = CryptoJS.AES.decrypt(cipherBase64, key, {
                keySize: 128 / 8,
                iv,
                padding: CryptoJS.pad.ZeroPadding,
            });

            const base64Plain = decrypted.toString(CryptoJS.enc.Utf8);

            return fromBase64(base64Plain);
        } catch (e) {
            return value;
        }
    };

    const toBool = (v) => {
        if (typeof v === 'boolean') {
            return v;
        }

        if (typeof v === 'number') {
            return v === 1;
        }

        if (typeof v === 'string') {
            return v === '1' || v.toLowerCase() === 'true';
        }

        return false;
    };

    // Расшифровываем чувствительные поля, которые теперь приходят зашифрованными
    data.diagType = decryptHello2(data.diagType);
    data.useSso = toBool(decryptHello2(data.useSso));
    data.ssoUrl = decryptHello2(data.ssoUrl);
    data.usePartner = toBool(decryptHello2(data.usePartner));
    data.platform = decryptHello2(data.platform);

    sessionStorage.setItem('usePartner', data.usePartner ? '1' : '0');

    data.loaded = true;
    store.commit('pages/setLms', { ...data });
    store.commit('platform/setSettings', { ...JSON.parse(data.platform) });
};
